import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    tooltip: {
      backgroundColor: ({ primaryColor }) => primaryColor,
    },
    arrow: {
      '&::before': {
        backgroundColor: ({ primaryColor }) => primaryColor,
      },
    },
    tooltipIcon: {
      paddingLeft: theme.spacing(1),
    },
  }),
);

export default useStyles;
